import React, { createContext, useContext, useState, useCallback } from 'react';

type DeckModalContextType = {
  isOpen: boolean;
  openDeckModal: () => void;
  closeDeckModal: () => void;
};

const DeckModalContext = createContext<DeckModalContextType | null>(null);

export const DeckModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openDeckModal = useCallback(() => setIsOpen(true), []);
  const closeDeckModal = useCallback(() => setIsOpen(false), []);
  return (
    <DeckModalContext.Provider value={{ isOpen, openDeckModal, closeDeckModal }}>
      {children}
    </DeckModalContext.Provider>
  );
};

export const useDeckModal = () => {
  const ctx = useContext(DeckModalContext);
  if (!ctx) throw new Error('useDeckModal must be used within DeckModalProvider');
  return ctx;
};
